'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/BackOffice'

import Dashboard from '@/Lists/Dashboard'
import ProductRow     from '@/Lists/Rows/ProductRow'

import FormElement from '@/Form/toolkit/FormElement'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

let app = window.app;

const header =
[
	{ label: 'Nom', name: 'name' },
	{ label: 'Type', name: 'pricing_tupe' },
	{ label: 'Artiste', name: '_artist.name' },
	{ label: 'Lieu', name: '_place.name' },
];

const fields = header.map(data => data.name);

const fields_with_timeout = ['searched'];

export default class ECsPage extends Component
{
	state =
	{
		searched: window.localStorage.getItem('ProductsList.searched') || '',
		delayed_searched: window.localStorage.getItem('ProductsList.searched') || '',

		with_disabled: window.localStorage.getItem('ProductsList.with_disabled') || '',

		status_messages: { }
	};

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	handleSearchChange = (value, data={ }, e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleChange({ value: value, name: data?.name, e });
	}

	handleChange = ({ value, name, e }) =>
	{
		const component = this, props = this.props, state = this.state;

		window.localStorage.setItem('ProductsList.' + name, value);

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		component.setState({ [name]: value });

		if (fields_with_timeout.includes(name) === false) return;

		if (component.search_timeout)
		{
			window.clearTimeout(component.search_timeout);
		}

		component.search_timeout = window.setTimeout(function ()
		{
			component.search_timeout = undefined;

			component.setState({ ['delayed_' + name]: value });
		},
		320);
	}

	handleFormElementChange = (e, data={ }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (e === null) return;

		component.handleChange({ value: data?.value, name: data?.name, e });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const filters =
		{
			searched: state.delayed_searched,

			no_theme: [true, 'true'].includes(state.no_theme)
		};

		var output =
		(
			<Layout history={ props.history } page_title="Billeterie">

				<div className="page-content">

					<div className="o-grid-4 u-content-between u-items-center
						u-margin-bottom-30">

						<div className="o-grid__item">
							<SearchBar hide_btn={ true } placeholder="Recherche..."
								handleChange={ component.handleSearchChange }
								value={ state.searched }
								name="searched"
							/>
						</div>

						<div className="o-grid__item">
							<FormElement type="checkbox" data={ state }
								onChange={ component.handleFormElementChange }
								value={ state.no_theme }
								name="no_theme" label="Sans thème principal"
								className="c-form-element c-form-element--dashboard"
							/>
						</div>

						<div className="o-grid__item"></div>

						<div className="o-grid__item u-flex u-content-end
							u-items-center">
							<Link href="/gestion-du-catalogue/nouveau-billet"
								className="c-btn c-btn--add u-no-margin-top">
								Nouveau billet
							</Link>
						</div>

					</div>

					<div className="o-content">
						<Dashboard model="Product" items-per-page={ 50 }
							url="/dashboard/products" filters={ filters }
							header={ header } fields={ fields }
							order="ASC" order-by="name"
							disable-sort={ filters.searched ? true : false }
							component={ ProductRow }
						/>
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
